<template>
  <div class="px-4 py-2" id="areasContrato">
    <!-- Linha superior: Dropdown + Qtd + Adicionar | Dispositivos + Armadilhas -->
    <div class="flex items-end gap-3">
      <div class="flex flex-col gap-1 flex-1">
        <label class="ft-label">Área</label>
        <el-select
          v-model="idAreaSelecionada"
          filterable
          clearable
          class="w-full"
          placeholder="Selecione uma área..."
          :popper-append-to-body="true"
        >
          <el-option
            v-for="area in areasDisponiveis"
            :key="area.id"
            :value="area.id"
            :label="area.nome"
          />
        </el-select>
      </div>
      <div>
        <vs-input-number
          color="success"
          v-validate="'required|numeric'"
          label="Quantidade."
          min="1"
          max="1"
          value="1"
          v-model="areaQtd"
          name="areaQtd"
        />
      </div>
      <vs-button
        :disabled="!idAreaSelecionada"
        color="success"
        type="relief"
        @click.prevent="addArea"
        >Adicionar</vs-button
      >
      <div>
        <vs-input-number
          color="success"
          label="Dispositivos."
          min="0"
          v-model="localModulos"
          @input="onModulosChange"
        />
      </div>
      <div>
        <vs-input-number
          color="success"
          label="Armadilhas."
          min="0"
          v-model="localArmadilhas"
          @input="onArmadilhasChange"
        />
      </div>
    </div>

    <!-- Lista de áreas adicionadas -->
    <div v-if="areasSelecionadas.length > 0" class="flex flex-col gap-1 mt-3">
      <div
        v-for="(item, idx) in areasSelecionadas"
        :key="idx"
        class="flex items-center justify-between border border-gray-100 rounded-lg px-4 py-2 hover:bg-gray-50 transition-colors"
      >
        <span class="text-sm text-gray-700">
          {{ item.qtd }} {{ item.nome }}(s)
        </span>
        <vs-button
          @click="removerArea(item.id_area)"
          type="relief"
          size="small"
          color="danger"
          >Remover</vs-button
        >
      </div>
    </div>

    <!-- Vazio -->
    <div
      v-else
      class="flex flex-col items-center justify-center py-6 text-gray-400"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="9" y1="21" x2="9" y2="9" />
      </svg>
      <span class="text-xs mt-1">Nenhuma área adicionada</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AreasContrato",

  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    contrato: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  data() {
    return {
      areasDisponiveis: [],
      areasSelecionadas: [],
      idAreaSelecionada: null,
      areaQtd: 1,
      localModulos: 0,
      localArmadilhas: 0,
    };
  },

  watch: {
    contrato: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.localModulos = val.modulos != null ? val.modulos : 0;
        this.localArmadilhas = val.armadilhas != null ? val.armadilhas : 0;
      },
    },
  },

  methods: {
    async getAreas() {
      try {
        this.areasDisponiveis = await this.$http.get("area");
      } catch (err) {
        var error = this.$httpErrors(err);
        this.$vs.notify(error);
      }
    },

    async getAreasSelecionadas() {
      if (!this.id) return;
      try {
        const result = await this.$http.get(
          "getAreasSelecionadas/" + this.id,
        );
        this.areasSelecionadas = Array.isArray(result) ? result : [];
        this.$emit("addAreas", this.areasSelecionadas);
      } catch (err) {
        var error = this.$httpErrors(err);
        this.$vs.notify(error);
      }
    },

    addArea() {
      if (!this.idAreaSelecionada) return;
      var areaSelecionada = this.areasDisponiveis.find(
        function (a) {
          return a.id === this.idAreaSelecionada;
        }.bind(this),
      );
      if (!areaSelecionada) return;

      // Evita duplicata
      var jaExiste = this.areasSelecionadas.some(function (a) {
        return a.id_area === areaSelecionada.id;
      });
      if (jaExiste) {
        this.$vs.notify({
          title: "Atenção",
          text: "Essa área já foi adicionada.",
          color: "warning",
        });
        return;
      }

      this.areasSelecionadas.push({
        nome: areaSelecionada.nome,
        qtd: 1,
        id_area: areaSelecionada.id,
      });
      this.areaQtd = 1;
      this.idAreaSelecionada = null;
      this.$emit("addAreas", this.areasSelecionadas);
    },

    removerArea(idArea) {
      var idx = this.areasSelecionadas.findIndex(function (a) {
        return a.id_area === idArea;
      });
      if (idx > -1) {
        this.areasSelecionadas.splice(idx, 1);
      }
      this.$emit("addAreas", this.areasSelecionadas);
    },

    onModulosChange(val) {
      this.$emit("update", Object.assign({}, this.contrato, { modulos: val }));
    },

    onArmadilhasChange(val) {
      this.$emit(
        "update",
        Object.assign({}, this.contrato, { armadilhas: val }),
      );
    },
  },

  async mounted() {
    await this.getAreas();
    await this.getAreasSelecionadas();
  },
};
</script>

<style scoped>
.ft-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #475569;
  margin: 0;
}
</style>
